"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PolicyDetails() {
  const policies = [{
    heading: "Information We Collect",
    content: "We collect personal information you voluntarily provide, such as your name and email when you contact us through our website.\n\nIn addition, our website may use cookies, pixels, and similar technologies to collect information about your activity on our site, such as pages visited, clicks, and device information. This information may be used for analytics and marketing purposes and may be shared with third-party platforms like Google or Meta (Facebook/Instagram) if you consent."
  }, {
    heading: "How We Use Your Information",
    content: "We use your information to respond to your inquiries, provide our services, and improve your experience on our website.\n\nMarketing and analytics tools may also use information about your activity to measure advertising performance, provide targeted content, and better understand user behavior. We do not sell your personal information to third parties."
  }, {
    heading: "Cookies and Consent",
    content: "When you visit our site, you may be presented with a cookie consent banner. Your preferences determine which marketing and analytics tags are activated. You can change or withdraw your consent at any time.\n\nNon-essential cookies, including those used for marketing or analytics, will only be activated if you consent."
  }, {
    heading: "Your Rights",
    content: "You can contact us at any time to access, correct, or delete the personal information you’ve provided. You can also manage your cookie preferences through the consent banner or by contacting us."
  }, {
    heading: "Contact Us",
    content: "For any questions regarding this privacy policy or your personal information, please contact us at hello@bozang.digital."
  }, {
    heading: "Updates to This Policy",
    content: "We may update this policy occasionally. Updates will be posted on this page. We encourage you to review this policy periodically."
  }];
  return <section className="bg-white py-20 px-6 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: "repeating-linear-gradient(45deg, transparent, transparent 35px, hsl(0,0%,60%) 35px, hsl(0,0%,60%) 36px)"
    }} />

      <div className="max-w-4xl mx-auto relative z-10">
        <h1 className="font-display text-4xl md:text-5xl font-bold text-black mb-4 text-left">
          Privacy Policy
        </h1>
        <p className="font-sans text-lg text-black/80 mb-12 text-left">
          Bozang Digital ("we," "our," or "us") respects your privacy. This
          policy explains how we handle the information you provide through our
          website.
        </p>

        <div className="space-y-10">
          {policies.map((policy, i) => <PolicyBlock key={i} policy={policy} index={i} />)}
        </div>
      </div>
    </section>;
}
function PolicyBlock({
  policy,
  index
}: {
  policy: {
    heading: string;
    content: string;
  };
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.3
  });
  return <div ref={ref} data-index={index} className="transition-all duration-[200ms] ease-out" style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0)" : "translateY(20px)",
    transitionDelay: `${index * 50}ms`
  }}>
      <h3 className="font-display text-2xl font-semibold text-black mb-3 text-left group cursor-pointer inline-block">
        <span className="border-b-2 border-transparent group-hover:border-[#2EAF7D] transition-all duration-200">
          {policy.heading}
        </span>
      </h3>
      <p className="font-sans text-base text-black/80 leading-relaxed text-left">
        {policy.content}
      </p>
    </div>;
}